<template>
  <form id="event-form" @submit.prevent="saveEvent">
    <div
      class="input-group"
    >
      <label class="field-label"
      >{{ availability ? 'Voľný termín' : 'Termín konzultácie' }}</label
      ><input
      type="datetime-local"
      v-model="meetingDate"
      :min="todayLong"
      class="text-input w-input date-input"
      maxlength="256"
      required
    />
    </div>
    <div class="input-group">
      <label class="field-label">Dĺžka konzultácie</label>
      <select v-model.number="duration" class="text-input w-input" required>
        <option :value="30">30 minút</option>
        <option :value="45">45 minút</option>
        <option :value="60">60 minút</option>
      </select>
    </div>
    <div
      class="input-group"
    >
      <label for="sprava" class="field-label"
      >Správa pre klienta</label
      >
      <textarea
        v-model="invitationForm.description"
        class="text-input w-input"
        id="sprava"
      />
    </div>
  </form>
</template>

<script>
export default {
  name: "OnlineConsultationEvent",
  props: {
    availability: {
      type: Boolean,
      default: false,
    },
    initialStart: {
      type: String,
      default: null,
    },
    initialEnd: {
      type: String,
      default: null,
    },
  },
  created () {
    const d = new Date();
    this.todayLong = [this.addZero(d.getFullYear()), this.addZero(d.getMonth() + 1), this.addZero(d.getDate())].join('-') + "T" + [this.addZero(d.getHours()), this.addZero(d.getMinutes())].join(':');
    if (this.initialStart) {
      const start = new Date(this.initialStart);
      this.meetingDate = this.formatLocalDateTime(start).slice(0, 16);
      if (this.initialEnd) {
        const minutes = Math.round((new Date(this.initialEnd) - start) / 60000);
        if ([30, 45, 60].includes(minutes)) this.duration = minutes;
      }
    }
  },
  methods: {
    setStartEndDate() {
      this.invitationForm.start = `${this.meetingDate}:00`
      const date = new Date(this.invitationForm.start);
      date.setMinutes(date.getMinutes() + this.duration);
      this.invitationForm.end = this.formatLocalDateTime(date);
      this.invitationForm.duration_minutes = this.duration;
    },
    saveEvent() {
      this.setStartEndDate();
      this.$emit("event-saved", this.invitationForm);
    },
    addZero (value) {
      if (value < 10) {
        return '0' + value;
      }
      return value;
    },
    formatLocalDateTime(date) {
      return [
        date.getFullYear(),
        this.addZero(date.getMonth() + 1),
        this.addZero(date.getDate()),
      ].join('-') + 'T' + [
        this.addZero(date.getHours()),
        this.addZero(date.getMinutes()),
        '00',
      ].join(':');
    }
  },
  data: () => ({
    todayLong: null,
    meetingDate: null,
    duration: 30,
    invitationForm: {
      type: "online_konzultacia",
      start: null,
      end: null,
      user: null,
      description: "Online konzultácia",
      meta: {
        placeId: null,
        addressMeta: null,
      }
    },
  }),
}
</script>

<style scoped>

</style>
